// src/sections/Portfolio.jsx

import { motion } from "framer-motion";
import { portfolio } from "../data/siteContent";
import SectionIntro from "../components/motion/SectionIntro";
import { cardReveal, staggerParent, viewportOnce } from "../utils/motion";

export default function Portfolio() {
  return (
    <section className="section-block section-block--light" id="portfolio">
      <div className="container-shell">
        <SectionIntro
          eyebrow={portfolio.eyebrow}
          title={portfolio.title}
          description={portfolio.description}
          align="center"
        />

        <div className="portfolio-tabs">
          {portfolio.categories.map((item, index) => (
            <button
              key={item}
              type="button"
              className={`portfolio-tab ${index === 0 ? "is-active" : ""}`}
            >
              {item}
            </button>
          ))}
        </div>

        <motion.div
          className="portfolio-grid"
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {portfolio.items.map((item, index) => (
            <motion.article
              key={`${item.title}-${index}`}
              className={`portfolio-card ${index === 0 ? "portfolio-card--featured" : ""}`}
              variants={cardReveal}
            >
              <div className="portfolio-card__media" />
              <div className="portfolio-card__content">
                <span className="portfolio-card__tag">{item.tag}</span>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
